<template>
  <div class="flex border-b last:border-b-0 border-solid border-gray-200 items-top py-4 text-default">
    <div class="w-1/6">{{ label }}</div>
    <div class="w-5/6"><slot /></div>
  </div>
</template>

<script setup lang="ts">
interface FDetailProps {
  label?: string;
}

defineProps<FDetailProps>();
</script>